import * as S from "./Styles";

export const Button = (props) => {
  return <S.Button {...props} />;
};
